import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../actions/apps";
import { setUserIsPatient } from "../../actions/user";
import { Mixpanel } from "../../mixpanel";
import { List } from "material-ui/List";

import _ from "lodash";
import Loader from "react-loader-advanced";

import AppListItem from "../AppListItem";
import AppFrame from "../Appframe/AppFrame";

import colors from "../../styles/colors";
import "../../resources/styles/UserAppsViewer.css";
import events from "../../services/events";

const style = {
  page: {
    display: "flex",
    flexFlow: "column",
    padding: 40,
    minHeight: "100vh",
  },
  container: {
    margin: 10,
    padding: 10,
  },
  table: {
    tableLayout: "auto",
  },
  titleColumn: {
    width: "40%",
  },
  codeColumn: {
    width: "12%",
  },
  buttonColumn: {
    width: "12%",
  },
  titleColumnText: {
    fontSize: 20,
  },
  codeColumnText: {
    fontSize: 18,
    color: colors.action,
  },
  listStyle: {
    display: "flex",
    flexWrap: "wrap",
  },
};

class ExternalResources extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: props.user.userId,
      appInfos: {},
      customApps: {},
      isPatient: props.user.isPatient,
      selectedAppId: -1,
      selectedAppIsLibOnly: false,
      cloneAppInfo: {},
      removeAppDialogData: {},
      popoverOpen: false,
      popoverAnchorEl: null,
      currentApp: null,
      width: 0,
      height: 0,
      sentOk: false,
    };
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    if (this.state.userId && this.state.userId > 0) {
      this.props.getUserApps(this.state.userId); // use this.state.userId to fix loading at refresh (rehydrate after request)
      this.props.getCustomApps(this.state.userId);
    } else {
      if (this.props.userId && this.props.userId > 0) {
        this.setState({ userId: this.props.userId });
        this.props.getUserApps(this.props.userId);
        this.props.getCustomApps(this.props.userId);
      } else {
        // wait for login to complete and user Id come in
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.userId || this.state.userId < 1) {
      // was waiting for userId, now set userId and request to get appInfo
      if (nextProps.user.userId || nextProps.user.userId > 0) {
        this.setState({ userId: nextProps.user.userId });
        this.props.getUserApps(nextProps.user.userId);
        this.props.getCustomApps(nextProps.user.userId);
      }
    } else {
      this.setState({
        appInfos: nextProps.apps.appInfos,
        isPatient: nextProps.user.isPatient,
        customApps: nextProps.apps.customApps,
      });
    }

    //When apps refresh see if any new apps exist and then set the store user to a provider in redux

    if (
      this.state.isPatient &&
      nextProps.user.isPatient &&
      !_.isEmpty(nextProps.apps.appInfos, true)
    ) {
      this.props.setUserIsPatient(false);
    }
  }

  openAppDashboard(appId, appName) {
    let link = `/patient-dashboard/${appId}/${this.props.user.userId}/LibraryOnly/${appName}`;
    events().trackUserEvent(
      "View Resource",
      appId,
      null,
      null,
      null,
      this.props.user.userId,
      null,
      "portal",
      appName,
      null,
      null
    );
    this.props.history.push(link);
  }

  renderAdditionalCustomAppResources(list) {
    return (
      <List className="channels-list">
        {_.values(list)
          .filter((i) => i.appInfo.appStatus === "Default")
          .map((app) => {
            return (
              <AppListItem
                key={app.appId}
                app={app.appInfo}
                customAppId={app.customAppId}
                isPatient={true}
                openChannel={(appId, appName) => {
                  //userId, customAppId, type, appName) {
                  this.openAppDashboard(
                    app.appInfo.appId,
                    appName
                  );
                }}
                whiteLabelSettings={this.props.whiteLabelSettings}
              />
            );
          })}
      </List>
    );
  }

  render() {
    return (
      <AppFrame
        auth={this.props.auth}
        header="External resources"
        optionsType="external"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={style.page}>
          <Loader show={this.props.apps.isLoading} message={"Loading..."}>
            <div>
              {this.renderAdditionalCustomAppResources(this.state.customApps)}
            </div>
          </Loader>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, customApps, whiteLabelSettings }) {
  return {
    userId: user.userId,
    user,
    apps,
    customApps,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  let allActions = { ...actionCreators, setUserIsPatient };
  return bindActionCreators(allActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalResources);



// WEBPACK FOOTER //
// ./src/layout/ExternalResources/ExternalResources.js